import { isWeixin } from '../../utils/utils'
import Model from '../hello'

class Login extends Model {

  // 登录
  toLogin (options) {
    options.url = isWeixin() && JSON.parse(window.localStorage.getItem('wxCodeData')) ? '/api/app/login/h5toPasswordAndCodeLogin' : '/api/app/login/toLogin'
    return this.post(options)
  }

  // 登录并注册
  registerOrLogin (options) {
    console.log(isWeixin(), JSON.parse(window.localStorage.getItem('wxCodeData')), 'registerOrLogin')
    options.url = isWeixin() && JSON.parse(window.localStorage.getItem('wxCodeData')) ? '/api/app/login/h5toPasswordAndCodeLogin' : '/api/app/login/toRegisterOrLogin'
    return this.post(options)
  }

  // 验证（登录|注册）账号
  validateLoginName (options) {
    options.url = '/api/app/login/validateLoginName'
    return this.post(options)
  }

  // 发送短信验证码
  sendSmsCode (options) {
    options.url = '/api/app/login/sendSmsCode'
    return this.post(options)
  }

  // 商务注册，发送邮箱验证码
  sendEmailCode (options) {
    options.url = '/api/app/login/sendEmailCode'
    return this.post(options)
  }

  // 商务注册，绑定邮箱
  saveEmployeeEmail (options) {
    options.url = '/api/app/login/saveEmployeeEmail'
    return this.post(options)
  }

  // 商务绑定术式
  saveEmployeeMode (options) {
    options.url = '/api/app/login/saveEmployeeMode'
    return this.post(options)
  }

  // 登录注册一体化
  toRegisterOrLogin (options) {
    options.url = '/api/app/login/toRegisterOrLogin'
    return this.post(options)
  }

  // 医生注册
  doctorRegister (options) {
    options.url = '/api/app/login/doctorRegister'
    return this.post(options)
  }

  // 校验功能是否授权
  getFunctionCodeList (options) {
    options.url = '/api/app/home/getFunctionCodeList'
    return this.post(options)
  }

  // 用户授权功能
  authorizationFunction (options) {
    options.url = '/api/app/home/authorizationFunction'
    return this.post(options)
  }

  // 实名认证
  updateDoctorInfo (options) {
    options.url = '/api/app/login/updateDoctorBaseInfo'
    return this.post(options)
  }

  // 实名认证
  validateLoginNameAndRegister (options) {
    options.url = '/api/app/login/validateLoginNameAndRegister'
    return this.post(options)
  }

  // 根据登录账号获取账号信息(医生账号医师资格证审核不通过，需要更新账号信息，先查下当前账号信息)
  getUserInfoByLoginName (options) {
    options.url = '/api/app/login/getUserInfoByLoginName'
    return this.post(options)
  }

  // 医生根据用户ID更新注册信息(医生账号医师资格证审核不通过，需要更新账号信息)
  updateDoctorInfoByUserId (options) {
    options.url = '/api/app/login/updateDoctorInfoByUserId'
    return this.post(options)
  }

  // 微信静默登录接口
  h5toWechtLogin (options) {
    options.url = '/api/app/login/h5toWechtLogin'
    return this.post(options)
  }

  // H5登录失败，匹配登录
  h5toPasswordAndCodeLogin (options) {
    options.url = '/api/app/login/h5toPasswordAndCodeLogin'
    return this.post(options)
  }

  // xb12369 2025年10月15日 13:43:14 绑定微信openId
  h5BindOpenId (options) {
    options.url = '/api/app/login/h5BindOpenId'
    return this.get(options)
  }

  // 医生实名认证编码照片信息查询
  queryDoctorAuthenInfo (options) {
    options.url = '/api/app/login/queryDoctorAuthenInfo'
    return this.get(options)
  }

  // 医生实名认证编码照片信息更新
  updateDoctorAuthenInfo (options) {
    options.url = '/api/app/login/updateDoctorAuthenInfo'
    return this.post(options)
  }

  // 医生实名认证审核结果查询
  getDoctorAuthentication (options) {
    options.url = '/api/app/doctor/getDoctorAuthentication'
    return this.get(options)
  }

  getEmployeeInfo (options) {
    options.url = '/api/app/employee/getPersonalInfo'
    return this.post(options)
  }
}

const loginModel = new Login()
export default loginModel
